
import axios from "axios";

const url = process.env.VUE_APP_BASE_URL;
// url
// https://ec1.yf.support/api1.0
// /api
const instance = axios.create({
    // baseURL: '/api'
    baseURL: ``,
  });


  // 添加请求拦截器
instance.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // config.headers.Authorization = localStorage.getItem('token')? "Bearer "+localStorage.getItem('token'):''
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });

// 添加响应拦截detail器
instance.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response.data;
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  });


  export default instance;